import { render, staticRenderFns } from "./Inicio.vue?vue&type=template&id=004ad568&scoped=true&"
var script = {}
import style0 from "./Inicio.vue?vue&type=style&index=0&id=004ad568&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "004ad568",
  null
  
)

export default component.exports